<template>
  <section class="about-me-detail contact-details">
    <div>
      <div>
        <article class="default-text">
          <h2>{{ contactMapTitle }}</h2>
          <div v-html="contactMapContent" />
          <div v-html="contactMapIframe"></div>
        </article>
      </div>
      <div>
        <div class="shape">
          <v-img-about-me-photo />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useMicrositeStore } from '../../stores/useMicrositeStore'
import VImgAboutMePhoto from "../v-img/VImgAboutMePhoto.vue";

const store = useMicrositeStore()

/**
 * Heading for the contact/map section.
 * @returns {string | undefined}
 */
const contactMapTitle = computed(() => store.microsite?.contactMapTitle)

/**
 * HTML content for the contact/map section.
 * May include address, hours, or other details.
 * @returns {string | undefined}
 */
const contactMapContent = computed(() => store.microsite?.contactMapContent)

/**
 * Iframe for the contact/map section.
 */
const contactMapIframe = computed(() => {
  return store.microsite?.contactMapIframe
})

</script>
